export default __webpack_public_path__ + "assets/video.158ff7a1.svg";